<template>
  <div>
    <div class="header">
      <NavBar @collapse-toggle="handleSidebarToggle"></NavBar>
    </div>
    <div class="sidebar" :class="sidebarCollapseClass">
      <Sidebar></Sidebar>
    </div>
    <div class="admin-main">
      <router-view />
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import Sidebar from "@/components/Sidebar.vue";
export default {
  name: "Admin",
  components: {
    NavBar,
    Sidebar
  },
  data() {
    return {
      sidebarCollapse: true
    };
  },
  watch: {
    $route() {
      this.sidebarCollapse = true;
    }
  },
  computed: {
    sidebarCollapseClass() {
      return this.sidebarCollapse ? "" : "sidebar__collapse-active";
    }
  },
  methods: {
    handleSidebarToggle() {
      this.sidebarCollapse = !this.sidebarCollapse;
    }
  }
};
</script>
